var _style, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000034054859813720996260000014606538144953189311_);}\n\t.st3{fill:url(#SVGID_00000054986500386291610960000000277865243941517728_);}\n\t.st4{fill:url(#SVGID_00000150060883675827053420000001552747029064064903_);}\n\t.st5{fill:url(#SVGID_00000057854373336293094350000004107353203796137347_);}\n\t.st6{fill:url(#SVGID_00000095325399843224286310000016420590481590149274_);}\n\t.st7{fill:url(#SVGID_00000091715957305476540380000003989036616494619045_);}\n\t.st8{fill:url(#SVGID_00000010302758492263631090000018348986965775329194_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.7,1000H144.3C64.9,1000,0,935.1,0,855.7V144.3C0,64.9,64.9,0,144.3,0h711.4C935.1,0,1000,64.9,1000,144.3 v711.4C1000,935.1,935.1,1000,855.7,1000z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 329.4517,
    cy: -192.6,
    r: 564.6508,
    gradientTransform: "matrix(1.76 0 0 -1.76 -344.62 500.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAE100"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#FADC04"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#FBCE0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#FCB720"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#FE9838"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#FF7950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#FF1C74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6C1CD1"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M934.59,210.98C926.4,134.23,865.78,73.6,789.02,65.41c-192.49-20.55-385.55-20.55-578.04,0 C134.22,73.6,73.6,134.22,65.41,210.98c-20.55,192.49-20.55,385.55,0,578.04c8.19,76.76,68.81,137.38,145.57,145.57 c192.49,20.55,385.55,20.55,578.04,0c76.76-8.19,137.38-68.81,145.57-145.57C955.14,596.53,955.14,403.48,934.59,210.98 L934.59,210.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106146690723775457740000006404670651811205248_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.1936,
    y1: 71.9598,
    x2: -1129.5063,
    y2: 929.6,
    gradientTransform: "matrix(1 0 0 -1 0 513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A1B5D8",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#90A2BD",
      stopOpacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#7C8B9C",
      stopOpacity: 0.76
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#748290"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106146690723775457740000006404670651811205248_)"
    },
    d: "M885.64,243.53 c-7.27-68.11-61.06-121.91-129.17-129.18c-170.81-18.22-342.13-18.22-512.94,0c-68.11,7.27-121.91,61.07-129.18,129.18 c-18.22,170.81-18.22,342.13,0,512.93c7.27,68.11,61.07,121.91,129.18,129.18c170.81,18.23,342.13,18.23,512.93,0 c68.12-7.27,121.91-61.06,129.18-129.18C903.87,585.66,903.87,414.34,885.64,243.53L885.64,243.53z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179629180580092956260000007050766372665701796_",
    gradientUnits: "userSpaceOnUse",
    x1: 500.0087,
    y1: -331.4681,
    x2: 500.0087,
    y2: -471.7574,
    gradientTransform: "matrix(1 0 0 -1 0 513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAE100",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#FCA800",
      stopOpacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#FE7300",
      stopOpacity: 0.63
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#FF5200",
      stopOpacity: 0.87
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179629180580092956260000007050766372665701796_)"
    },
    d: "M63.49,770.36 c0.62,6.22,1.26,12.44,1.92,18.66c8.19,76.75,68.81,137.38,145.57,145.57c192.49,20.55,385.55,20.55,578.04,0 c76.76-8.19,137.38-68.81,145.57-145.57c0.67-6.22,1.3-12.44,1.93-18.66H63.49z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022537430411391143570000012654795090023647896_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.8076,
    y1: 65.4737,
    x2: 226.068,
    y2: 288.2135,
    gradientTransform: "matrix(1 0 0 -1 0 513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#833AB4",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#833AB4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022537430411391143570000012654795090023647896_)"
    },
    d: "M934.59,789.01 c11.04-103.43,16.14-207.02,15.31-310.6L744.18,272.69c-25.7-29.34-63.24-47.65-107.35-49.24c-90.71-3.27-181.71-3.1-272.44,0.01 c-75.35,2.6-128.05,53.24-141.56,127.68c-2.38,13.14-3.81,26.46-5.68,39.69v218.23c1.04,7.07,2.56,14.11,3.04,21.22 c3.02,45.28,21.63,84.06,51.42,110.3l209.34,209.34c102.74,0.72,205.48-4.39,308.07-15.34C865.78,926.39,926.4,865.77,934.59,789.01 L934.59,789.01z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013153383758250967100000004749393735025191847_",
    gradientUnits: "userSpaceOnUse",
    x1: 666.8173,
    y1: -360.1576,
    x2: 555.6479,
    y2: 163.9296,
    gradientTransform: "matrix(1 0 0 -1 0 513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#833AB4",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#833AB4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013153383758250967100000004749393735025191847_)"
    },
    d: "M934.59,789.02 c-8.18,76.75-68.82,137.38-145.57,145.57c-102.58,10.95-205.34,16.06-308.06,15.34L271.93,740.9 c24.23,21.21,55.82,34.13,92.47,35.51c90.71,3.41,181.73,3.32,272.43,0.05c82.04-2.97,141.41-63.69,143.97-145.73 c2.73-87.11,2.73-174.44,0-261.55c-1.17-37.85-14.45-71.15-36.48-96.35l205.59,205.59C950.73,581.99,945.64,685.59,934.59,789.02z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008835509503159481400000018100354841651913918_",
    gradientUnits: "userSpaceOnUse",
    x1: 709.1235,
    y1: -196.1197,
    x2: 262.5941,
    y2: 250.4097,
    gradientTransform: "matrix(1 0 0 -1 0 513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#833AB4",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#833AB4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008835509503159481400000018100354841651913918_)"
    },
    d: "M606.2,402.55 c-26.35-28.69-64.17-46.7-106.2-46.7c-79.61,0-144.15,64.54-144.15,144.15c0,42.03,18,79.84,46.7,106.2l333.52,333.52 c17.65-1.54,35.31-3.25,52.95-5.13c76.76-8.19,137.38-68.81,145.57-145.57c1.88-17.64,3.59-35.29,5.13-52.95L606.2,402.55 L606.2,402.55z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153707165582382200120000005254441535279150756_",
    gradientUnits: "userSpaceOnUse",
    x1: 742.244,
    y1: 74.0593,
    x2: 594.5842,
    y2: 221.719,
    gradientTransform: "matrix(1 0 0 -1 0 513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#833AB4",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#833AB4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153707165582382200120000005254441535279150756_)"
    },
    d: "M948.27,596.95L679.84,328.53 c-6.26-8.22-16.13-13.55-27.26-13.55c-18.94,0-34.3,15.35-34.3,34.3c0,11.13,5.33,21,13.55,27.26l311.63,311.63 C945.57,657.77,947.18,627.36,948.27,596.95L948.27,596.95z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023973713123441425300000015701757605811846311_",
    gradientUnits: "userSpaceOnUse",
    x1: 678.6935,
    y1: 190.4497,
    x2: 314.6341,
    y2: -173.6199,
    gradientTransform: "matrix(1 0 0 -1 0 513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#833AB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#9C3495"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#DC2546"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FD1D1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#FC6831"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#FC9B40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#FCAF45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#FDB750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#FECB6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#FFD87A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDC80"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023973713123441425300000015701757605811846311_)"
    },
    d: "M217.15,390.84 c1.87-13.24,3.3-26.55,5.68-39.69c13.51-74.44,66.21-125.09,141.56-127.68c90.73-3.12,181.73-3.28,272.44-0.01 c82.01,2.95,141.41,63.68,143.97,145.72c2.73,87.12,2.73,174.44,0,261.56c-2.56,82.04-61.93,142.76-143.96,145.72 c-90.71,3.27-181.73,3.36-272.44-0.05c-82.03-3.08-138.73-63.95-144.22-146.11c-0.47-7.11-2-14.15-3.04-21.22 c0-72.74,0-145.48,0-218.22L217.15,390.84z M500.07,727.82c41.51,0,83.07,1.24,124.53-0.29c65-2.41,104.99-41.2,106.51-106.15 c1.88-80.92,1.88-161.95,0-242.88c-1.52-64.93-41.53-104.63-106.51-106.01c-82.47-1.74-165.04-1.73-247.51,0 c-64.48,1.35-104.58,40.25-106.33,104.47c-2.23,81.94-2.23,164.03,0,245.98c1.75,64.21,41.85,102.21,106.34,104.6 C418.04,729.07,459.08,727.83,500.07,727.82L500.07,727.82z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.15,390.84c1.87-13.24,3.3-26.55,5.68-39.69c13.51-74.44,66.21-125.09,141.56-127.68 c90.73-3.12,181.73-3.28,272.44-0.01c82.01,2.95,141.41,63.68,143.97,145.72c2.73,87.12,2.73,174.44,0,261.56 c-2.56,82.04-61.93,142.76-143.96,145.72c-90.71,3.27-181.73,3.36-272.44-0.05c-82.03-3.08-138.73-63.95-144.22-146.11 c-0.47-7.11-2-14.15-3.04-21.22c0-72.74,0-145.48,0-218.22L217.15,390.84z M500.07,727.82c41.51,0,83.07,1.24,124.53-0.29 c65-2.41,104.99-41.2,106.51-106.15c1.88-80.92,1.88-161.95,0-242.88c-1.52-64.93-41.53-104.63-106.51-106.01 c-82.47-1.74-165.04-1.73-247.51,0c-64.48,1.35-104.58,40.25-106.33,104.47c-2.23,81.94-2.23,164.03,0,245.98 c1.75,64.21,41.85,102.21,106.34,104.6C418.04,729.07,459.08,727.83,500.07,727.82L500.07,727.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500,355.85c-79.61,0-144.15,64.54-144.15,144.15S420.39,644.15,500,644.15S644.15,579.61,644.15,500 S579.61,355.85,500,355.85L500,355.85z M500,594.52c-52.21,0-94.52-42.32-94.52-94.52s42.32-94.52,94.52-94.52 c52.2,0,94.52,42.32,94.52,94.52S552.2,594.52,500,594.52L500,594.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M686.86,349.28c0,18.94-15.35,34.29-34.29,34.29s-34.3-15.35-34.3-34.29c0-18.94,15.36-34.3,34.3-34.3 S686.86,330.33,686.86,349.28z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.2c496fbaeb8290b0e88ded48624d8cea.svg";
export { ForwardRef as ReactComponent };